export default __webpack_public_path__ + "static/media/Group9167.905c9857.svg";